const modulos = (value, div) => {
    return ((+(value * 100).toFixed(0)) % (+(div * 100).toFixed(0)));
};

export default modulos;